// extracted by mini-css-extract-plugin
export var activeFilterButton = "_qp-c";
export var backButton = "_qp-4";
export var backIcon = "_qp-5";
export var chevronShortcut = "_qp-6";
export var container = "_qp-1";
export var editor = "_qp-8";
export var editorWrapper = "_qp-7";
export var prefix = "_qp-2";
export var searchIcon = "_qp-3";
export var suffix = "_qp-9";
export var suffixContent = "_qp-a";
export var suffixText = "_qp-b";
export var wrapper = "_qp-0";